import * as React from "react";

const LoadingForm = ({ showMoreRows }) => {
  const rows = showMoreRows ? 8 : 4;

  return (
    <div className="xflow-form-skeleton" aria-hidden="true">
      {Array.from({ length: rows }).map((_, index) => (
        <div className="xflow-form-skeleton-row" key={index}>
          <span></span>
          <span></span>
        </div>
      ))}
      <div className="xflow-form-skeleton-wide"></div>
      <div className="xflow-form-skeleton-actions">
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default LoadingForm;
